import { render, staticRenderFns } from "./MessageModal.vue?vue&type=template&id=718e3815&lang=pug"
import script from "./MessageModal.vue?vue&type=script&lang=ts"
export * from "./MessageModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports